import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AdminapiService } from '../shared/services/adminapi.service';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {
  constructor(private router: Router,public adminApi: AdminapiService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      const loggedIn = this.adminApi.isLoggedIn();
   
      // provides the route configuration options.
      const { routeConfig } = route; 
      
      // provides the path of the route.
      const { path } = routeConfig as Route; 
      
      // if (path?.includes('admin') && role === 'admin') {
      // // if user is administrator and is trying to access admin routes, allow access.
   
      //   return true;
      // }
      
      // if (path?.includes('customer') && role === 'customer') {
      // // if user is customer and is accessing customer route, allow access.
   
      //   return true;
      // }
       
      if(!loggedIn){
        this.router.navigateByUrl('/admin/login');
        return false;
      }

      // if ((path?.includes('guest') || path?.includes('home')) && (role === 'customer' || role === 'administrator')) {
      // // if a logged in user goes to Guest or Home, navigate to their respective dashboard.
   
      //     this.router.navigateByUrl(role === 'customer' ? '/customer' : '/admin');
      //     return false;
      // }
      
      // for any other condition, navigate to the forbidden route.
   
      return true;
  }
  
}
